import RangerGame from './RangerGame';
import { rangerDefinition } from './rangerDefinition';
import { RANGER_ICON_ASSET_PATHS } from './rangerVisuals';

const rangerIcons = {
  ranger: {
    id: 'ranger',
    src: `${process.env.PUBLIC_URL}${RANGER_ICON_ASSET_PATHS.ranger}`,
  },
  scout: {
    id: 'ranger-spy',
    baseId: 'ranger',
    src: `${process.env.PUBLIC_URL}${RANGER_ICON_ASSET_PATHS['ranger-spy']}`,
  },
  medic: {
    id: 'ranger-medic',
    baseId: 'ranger',
    src: `${process.env.PUBLIC_URL}${RANGER_ICON_ASSET_PATHS['ranger-medic']}`,
  },
};

export const rangerGameModule = {
  id: rangerDefinition.id,
  name: rangerDefinition.name,
  summary: rangerDefinition.summary,
  component: RangerGame,
  definition: rangerDefinition,
  accent: 'green',
  icon: rangerIcons.ranger,
  releaseState: 'released',
  controls: {
    movement: 'analog-2d',
    actions: ['primary', 'secondary'],
    notes: 'Move through patrol missions with keyboard or touch, fire rifle/grenades in the movement direction, and strike nearby enemies with the bayonet.',
  },
  playableIcons: [
    { id: 'ranger', name: 'Ranger', icon: rangerIcons.ranger },
    { id: 'ranger-medic', name: 'Medic', icon: rangerIcons.medic },
    { id: 'ranger-spy', name: 'Spy', icon: rangerIcons.scout },
  ],
};
